import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { ConnectivityService } from 'app/shared/connectivity.service';
import { Observable, Subscription } from 'rxjs';
import { distinctUntilChanged, pairwise } from 'rxjs/operators';


@Component({
  selector: 'app-offline-banner',
  templateUrl: './offline-message.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineMessageComponent implements OnInit, OnDestroy {
  estaEnLinea$: Observable<boolean>;
  mostrarReconectado = false;
  private subscripcion?: Subscription;

  constructor(
    private connectivityService: ConnectivityService,
    private cd: ChangeDetectorRef
  ) {
    this.estaEnLinea$ = this.connectivityService.online$;
  }

  ngOnInit() {
    // Mostrar mensaje temporal cuando la conexion cambia de offline a online
    this.subscripcion = this.estaEnLinea$
      .pipe(distinctUntilChanged(), pairwise())
      .subscribe(([prev, curr]) => {
        if (prev === false && curr === true) {
          this.mostrarReconectado = true;
          this.cd.markForCheck();
          setTimeout(() => {
            this.mostrarReconectado = false;
            this.cd.markForCheck();
          }, 3000);
        }
      });
  }

  ngOnDestroy(): void {
    this.subscripcion?.unsubscribe();
  }


}
